// extracted by mini-css-extract-plugin
export default {"buttons":"FundsOrigin_buttons__SbXVF","buttonsList":"FundsOrigin_buttonsList__8Zd4S"};